export default {
    name: "DataSearchInputType",
    data() {
        return {
            result: {}
        };
    },
    model: {
        prop: "value",
        event: "change"
    },
    props: {
        value: {
            type: Object,
            default: () => ({})
        },
        agentAndKeyword: {
            type: Boolean,
            default: false
        }
    },
    watch: {
        value: {
            handler() {
                this.result = { ...this.value };
            },
            immediate: true
        }
    },
    methods: {
        submit() {
            const { type, value } = this.result;
            this.$emit("change", {
                type,
                value: value && value.trim()
            });
        }
    }
};
